<template>
  <div>
    <v-text-field
      v-if="inputFocus"
      class="filledColor mb-0 pb-0 pt-1 textInBottom"
      dense
      v-model="valueNum"
      :label='placeholder'
      @blur="onCompliteChange($event)"
      @change="onCompliteChange($event)"
      @keydown="onlyNumber($event)"
      :messages="messages"
    ></v-text-field>
    <v-text-field v-else
      class="filledColor mb-0 pb-0 pt-1 textInBottom"
      dense
      :value="valueText"
      :label='placeholder'
      @focus='changeFocus($event)'
      :messages="messages"
    ></v-text-field>
  </div>
</template>

<script>
export default {
  name: "price_input",
  data: ()=>({
      inputFocus: false
  }),
  props: {
    id: null,
    value: null,
    required: { type: Boolean },
    placeholder: {type: String, default: 'Введите текст'},
    messages: null
  },
  computed: {
    valueNum: {
      get(){return this.value !== null && this.value !== undefined && this.value !== '' ? Number(this.removeCommas(this.value)) : null ;},
      set(val){val!=='' ? this.$emit('input',this.removeCommas(val)) : this.$emit('input', null)}
    },
    valueText() {
      return this.value !== null && this.value !== undefined && this.value !== ''? this.addCommas(this.valueNum) : ''
    },
  },
  methods:{
      changeFocus(evt){
          this.inputFocus = true
      },
      onCompliteChange(evt){
          this.inputFocus = false
      },
  }
};
</script>

<style lang="scss">
.theme--light.filledColor.v-input:not(.v-input--is-disabled) input {
  color: #217899;
}
.textInBottom {
    .v-text-field__details {
      display: inline;
      height: auto;
      min-height: auto;
      .theme--light.v-messages {
        height: auto;
        .v-messages__message {
          margin-top: 2px;
          color: red;
        }
      }
    }
  }
</style>